// extracted by mini-css-extract-plugin
export default {"container":"error-tooltip_container__nZpwn","details":"error-tooltip_details__OsSTD"};